import React from 'react';
import './panel.css';

interface PanelProps {
  title?: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  /** Lets a child popover taller than the panel escape its `overflow: hidden`. */
  overflowVisible?: boolean;
}

export function Panel({
  title,
  headerRight,
  children,
  overflowVisible,
}: PanelProps): React.ReactElement {
  const panelClass = ['mc-panel', overflowVisible ? 'mc-panel--overflow-visible' : '']
    .filter(Boolean)
    .join(' ');
  return (
    <div className={panelClass}>
      <div className="mc-panel__glow" />
      {title && (
        <div className="mc-panel__header">
          <div className="mc-panel__title-group">
            <div className="mc-panel__title-bar" />
            <h3 className="mc-panel__title">{title}</h3>
          </div>
          {headerRight}
        </div>
      )}
      {children}
    </div>
  );
}
